import { FC } from 'react';

// Third party
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

// Types
import { TBaseSelect } from './type';

const BaseSelect: FC<TBaseSelect> = ({
  selectProps,
  leftIcon: LeftIcon,
  onLeftIconClick,
  disabled = false,
  maxHeight,
}) => (
  <Select
    {...selectProps}
    value={selectProps?.defaultValue}
    id="select"
    size="small"
    disabled={disabled}
    variant={selectProps?.variant || 'outlined'}
    multiple={selectProps?.multiple || false}
    fullWidth
    onChange={selectProps?.onChange}
    MenuProps={{
      PaperProps: {
        style: {
          maxHeight,
        },
      },
    }}
    renderValue={(selected) => (
      <Typography fontSize={14}>
        {selectProps?.multiple ? (selected as Array<string>).join(' ,') : selected as string}
      </Typography>
    )}
  >
    {
      selectProps?.items.map((item) => (
        <MenuItem key={item} value={item}>
          <div className="justify-space-between align-center w-100">
            <Typography fontSize={13}>
              {item}
            </Typography>
            {LeftIcon && <LeftIcon onClick={onLeftIconClick} item={item} />}
          </div>
        </MenuItem>
      ))
      }
  </Select>
);

export {
  BaseSelect,
};
